import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle, AlertTriangle, Info } from 'lucide-react';
import toast from 'react-hot-toast';

const ToastTester = () => {
  const showToast = (type) => {
    const message = `This is a ${type} toast message`;
    toast.dismiss();
    switch (type) {
      case 'success':
        toast.success(message);
        break;
      case 'error':
        toast.error(message);
        break;
      case 'warning':
      case 'info':
        toast(message, { type });
        break;
      default:
        toast(message);
    }
  };

  const toastTypes = [
    { type: 'success', icon: CheckCircle, color: 'bg-green-500', label: 'Success Toast' },
    { type: 'error', icon: XCircle, color: 'bg-red-500', label: 'Error Toast' },
    { type: 'warning', icon: AlertTriangle, color: 'bg-yellow-500', label: 'Warning Toast' },
    { type: 'info', icon: Info, color: 'bg-blue-500', label: 'Info Toast' }
  ];

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Toast Notification Tester</h2>
      <p className="text-gray-600 mb-6">Test different types of toast notifications to ensure proper styling and behavior.</p>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {toastTypes.map(({ type, icon: Icon, color, label }) => (
          <motion.button
            key={type}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => showToast(type)}
            className={`${color} text-white p-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-200 flex flex-col items-center space-y-2`}
          >
            <Icon size={24} />
            <span className="text-sm font-medium">{label}</span>
          </motion.button>
        ))}
      </div>

      <div className="mt-6 p-4 bg-gray-50 rounded-xl">
        <h3 className="font-semibold text-gray-800 mb-2">Toast Testing Guidelines:</h3>
        <ul className="text-sm text-gray-600 space-y-1">
          <li>• <strong>Success:</strong> For successful operations (save, update, etc.)</li>
          <li>• <strong>Error:</strong> For failures and critical issues</li>
          <li>• <strong>Warning:</strong> For caution messages and non-critical issues</li>
          <li>• <strong>Info:</strong> For general information and tips</li>
        </ul>
      </div>
    </div>
  );
};

export default ToastTester;
